import 'core-js';
import React from 'react';
import ReactDOM from 'react-dom';
import RootPage from './RootPage';
import Moment from 'moment';
import ErrorHandler from './errorHandler';
import ReactUpdates from 'react-dom/lib/ReactUpdates';
import './index.css';

let locale = 'pt-BR';
let momentFile = require('moment/locale/' + locale.toLowerCase());
Moment.updateLocale(locale.toLowerCase(), momentFile);

let I18n = require('i18n-react').default;
let I18nFile = require('./locale/' + locale + '.json');
I18n.setTexts(I18nFile);

ReactUpdates.injection.injectBatchingStrategy(ErrorHandler);

window.addEventListener('load', function() {
  document.getElementById('ta-header').outerHTML = '';
  ReactDOM.render(<RootPage headerComponentEnabled={true} />, document.getElementById('root'));
});



// WEBPACK FOOTER //
// ./src/index.js